/* eslint-disable max-len */
import styled from 'styled-components';
import DocumentSVGIcon from '../../assets/images/document-icon.svg';
import DocumentSVGLightIcon from '../../assets/images/document-icon-light.svg';

const DocumentsIcon = styled.span`
  background: ${(props) =>
    props.theme.palette.type === 'dark'
      ? `url("${DocumentSVGIcon}") no-repeat left center`
      : `url("${DocumentSVGLightIcon}") no-repeat left center`};
  background-size: 17px 17px;
  display: block;
  position: relative;
  height: 27px;
  width: 17px;
`;

export default DocumentsIcon;
